import { ATTRIBUTES } from '@/features/attributes/constants/attributes'
import { type VipQueryAttributeAll } from '@/types/listings'

export const getVehicleStockNumber = (attributes: VipQueryAttributeAll) => {
  return attributes?.find((attribute) => attribute?.canonicalName === ATTRIBUTES.STOCK)?.values?.[0]
}
